// extracted by mini-css-extract-plugin
export default {"business_card":"business-card_business_card__J+ST3","sticky_btn":"business-card_sticky_btn__01eGr"};